import { Theme } from './services/theme-utils.service';

export const RECRUITEE_THEME_LS_KEY = 'recruitee-theme';
export const RECRUITEE_THEME_MIGRATED_LS_KEY = 'recruitee-theme-migrated';
export const RECRUITEE_THEME_DEFAULT = 'light';

type BackgroundSpecificTokenExtract<T> = Extract<T, `colorBg${string}`>;
export type BackgroundToken = BackgroundSpecificTokenExtract<keyof Theme>;
